
import AbstractSymbolBehaviour from "slotworks/components/matrix/symbol/behaviours/abstract-symbol-behaviour";
import Layers from "slotworks/graphics/layers/layers";

export default class DisplaySymbolBehaviour extends AbstractSymbolBehaviour {

    public static() {
        this.cleanUp();
    }

    public display() {
        this.symbol.tint(0xffffff);
        this.symbol.setLayer(Layers.SymbolAnimations);
        
        return super.display();
    }

    private cleanUp() {
        this.symbol.setLayer(Layers.MatrixContent);
    }
};



// WEBPACK FOOTER //
// ./~/slotworks/components/matrix/symbol/behaviours/display-symbol-behaviour.ts